// Admin/Employee surface switcher. Only renders when caller is an admin.
// FORKED — owns its own admin check so it can be dropped into either layout
// without coupling EmployeeLayout to the admin-guard module.
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';

export function RoleSwitcher({ current }: { current: 'admin' | 'employee' }) {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('pulse_org_members')
        .select('role')
        .eq('user_id', user.id)
        .eq('role', 'admin')
        .maybeSingle();
      if (!cancelled) setIsAdmin(!!data);
    })();
    return () => { cancelled = true; };
  }, [user]);

  if (!isAdmin) return null;

  return (
    <div className="px-3 pt-3">
      <div className="flex items-center gap-1 p-1 rounded-md bg-muted/60 border border-border">
        <NavLink
          to="/app/employee"
          className={cn(
            'flex-1 text-center text-xs py-1.5 rounded transition-colors',
            current === 'employee'
              ? 'bg-background text-foreground shadow-sm font-medium'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          Employee
        </NavLink>
        <NavLink
          to="/app/admin"
          className={cn(
            'flex-1 text-center text-xs py-1.5 rounded transition-colors',
            current === 'admin'
              ? 'bg-background text-foreground shadow-sm font-medium'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          Admin
        </NavLink>
      </div>
    </div>
  );
}
